export default __webpack_public_path__ + "static/media/menu-glow-top.beae08bd.svg";